import React, { Component } from 'react';
import { useNavigate } from "react-router-dom";
import { withTranslation } from 'react-i18next';

class Disclaimer extends Component {
  render() {
    const { t } = this.props;

    return (
      <div>
        <div className="container" style={{ paddingTop: '25px', paddingBottom: '50px' }}>
          <h2>{t('disclaimer_title')}</h2>
          
          <p>{t('disclaimer_p1')}</p>
          <p>{t('disclaimer_p2')}</p>
          <p>{t('disclaimer_p3')}</p>
          <p>{t('disclaimer_p4')}</p>
          <p>{t('disclaimer_p5')}</p>
          
          <br />
          <strong>{t('disclaimer_policy_title')}</strong>
          <p>{t('disclaimer_policy_desc')}</p>
        </div>
      </div>
    );
  }
}


function WithNavigate(props) {
  const navigate = useNavigate();
  const TranslatedDisclaimer = withTranslation()(Disclaimer);
  return <TranslatedDisclaimer {...props} navigate={navigate} />;
}

export default WithNavigate;